(function(){
  const SELECTOR = 'a.lb, a[data-lightbox], a.is-lightbox'; // customize if you like

  // build overlay once
  const overlay = document.createElement('div');
  overlay.className = 'lb-overlay';
  overlay.innerHTML = `
    <button class="lb-close" aria-label="Close">&times;</button>
    <img alt="" loading="lazy" decoding="async" />
  `;
  document.addEventListener('DOMContentLoaded', () => document.body.appendChild(overlay));

  const imgEl = () => overlay.querySelector('img');
  const open = (src, alt='') => {
    imgEl().src = src; imgEl().alt = alt || '';
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden'; // lock scroll
  };
  const close = () => {
    overlay.classList.remove('is-open');
    imgEl().src = '';
    document.documentElement.style.overflow = '';
  };

  // click handlers
  document.addEventListener('click', e => {
    const link = e.target.closest(SELECTOR);
    if (!link) return;

    const href = link.getAttribute('href') || '';
    if (!/\.(png|jpe?g|webp|gif|avif|svg)(\?.*)?$/i.test(href)) return; // only images
    e.preventDefault();
    open(href, link.getAttribute('aria-label') || link.getAttribute('title') || link.textContent || '');
  });

  // close on overlay click (but not when clicking the image)
  overlay.addEventListener('click', e => {
    if (e.target === overlay || e.target.classList.contains('lb-close')) close();
  });

  // ESC to close
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });
})();
